var App = App || {};

App.Forms = (function () {
    'use strict';

    function Validation() {
        $("form.kentico-form").each(function (e) {
            FormLoad($(this));
            FormSubmit($(this));
        });

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // FORM LOAD
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function FormLoad(Form) {

            // update kentico's radio and checkbox markup to match bootstrap
            Form.find(".ktc-radio-list > span.ktc-radio, span.ktc-checkbox").each(function () {
                var input = $(this).find("input.form-control");
                var label = $(this).find("label");
                var id = input.attr("id").replace(" ", "_");

                input.removeClass("form-control").addClass("form-check-input").attr("id", id);
                label.addClass("form-check-label").attr("for", id);

                var markup = $(this).html();
                $(this).replaceWith("<div class=\"form-check\">" + markup + "</div>");
            });

            // make file uploader "delete file" link keyboard accessible
            Form
                .find(".ktc-uploader-text-button")
                .attr("href", "#")
                .on("click", function (e) { e.preventDefault(); });

            // different validation tactics
            Form.find(".zag-validation-input-text").on("input", function () { ValidateText($(this)); CountErrors($(this)); });
            Form.find(".zag-validation-input-radio").on("input", function () { ValidateRadio($(this)); CountErrors($(this)); });
            Form.find(".zag-validation-input-checkboxes").on("input", function () { ValidateCheckboxes($(this)); CountErrors($(this)); });
            Form.find(".zag-validation-input-checkbox").on("input", function () { ValidateCheckbox($(this)); CountErrors($(this)); });
            Form.find(".zag-validation-input-file").on("input", function () { ValidateFile($(this)); CountErrors($(this)); });
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // FORM SUBMIT
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        function FormSubmit(Form) {
            // remove kentico's update and onsubmit functions
            var KenticoSubmit = Form.attr("onsubmit") || "",
                KenticoUpdate = Form.attr("data-ktc-ajax-update") || "",
                CustomSubmit = Form.attr("data-submit");

            Form.removeAttr("onsubmit data-ktc-ajax-update").on("submit", function (e) {
                e.preventDefault();

                $(this).removeClass("kentico-form-loaded").addClass("kentico-form-submitted");

                // different validation tactics
                $(this).find(".zag-validation-input-text").each(function () { ValidateText($(this)); CountErrors($(this)); });
                $(this).find(".zag-validation-input-radio").each(function () { ValidateRadio($(this)); CountErrors($(this)); });
                $(this).find(".zag-validation-input-checkboxes").each(function () { ValidateCheckboxes($(this)); CountErrors($(this)); });
                $(this).find(".zag-validation-input-checkbox").each(function () { ValidateCheckbox($(this)); CountErrors($(this)); });
                $(this).find(".zag-validation-input-recaptcha").each(function () { ValidateRecaptcha($(this)); CountErrors($(this)); });
                $(this).find(".zag-validation-input-file").each(function () { ValidateFile($(this)); CountErrors($(this)); });

                // if there are no error messages, submit the form
                if ($(this).find(".zag-validation-invalid").length > 0) {
                    $(this).find(".zag-validation-invalid").first().focus();
                }
                else {
                    if (KenticoSubmit !== "" && KenticoUpdate !== "") {
                        //replace kentico's onsubmit, etc. function from attribute list
                        $(this).attr({ "onsubmit": KenticoSubmit, "data-ktc-ajax-update": KenticoUpdate });
                        // and allow it to submit
                        $(this).off("submit").submit().find("input[type='submit']").prop("disabled", "true");

                        // The user may have had to scroll through the form to fill it out. If so, they may not see the top of the form any longer, which
                        // means they also won't see the "thank you" note to indicate their submission was successful. Scroll up so they see it.
                        $("html, body").animate({
                            scrollTop: $(this).offset().top - 65
                        }, 300);
                    }
                    // if there is a custom submit function defined as a data attribute
                    else if (CustomSubmit !== undefined) {
                        eval(CustomSubmit);
                    }
                    // if there is no onsubmit, etc. function from attribute list maybe this isn't a Kentico form so submit it
                    else {
                        $(this).off("submit").submit();
                    }
                }
            });
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // VALIDATE TEXT
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function ValidateText(Component) {
            // validate individual input against required
            Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']").each(function () {
                Component.val() !== "" ? $(this).hide() : $(this).show()
            });

            // validate individual input against min-length
            Component.parents(".form-group").find(".zag-validation-error[data-ruletype='minlength']").each(function () {
                Component.val().length >= $(this).attr("data-rulemin") ? $(this).hide() : $(this).show()
            });

            // validate individual input against max-length
            Component.parents(".form-group").find(".zag-validation-error[data-ruletype='maxlength']").each(function () {
                Component.val().length <= $(this).attr("data-rulemax") ? $(this).hide() : $(this).show()
            });

            // validate individual input against compare to another field
            Component.parents(".form-group").find(".zag-validation-error[data-ruletype='compare']").each(function () {

                var Operator = $(this).attr("data-rulecomparison"),
                    CompareGuid = $(this).attr("data-rulecomparisonfield"),
                    CompareValue = $("[data-guid='" + CompareGuid + "']").val();

                if (Component.val() !== "" && CompareValue !== "") {
                    if (Operator === "NotEqual") {
                        Component.val() !== CompareValue ? $(this).hide() : $(this).show()
                    }
                    else if (Operator === "Equal") {
                        Component.val() === CompareValue ? $(this).hide() : $(this).show()
                    }
                }
                else {
                    $(this).show()
                }

            });

            // validate individual input against regex
            Component.parents(".form-group").find(".zag-validation-error[data-ruletype='regex']").each(function () {
                Component.val().match($(this).attr("data-ruleregex")) ? $(this).hide() : $(this).show()
            });
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // VALIDATE RADIO
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function ValidateRadio(Component) {
            // because this is structured data we can assume no validation rule other than required is needed
            var ComponentName = Component.attr("name");
            var ComponentValue = $("input[name='" + ComponentName + "']:checked").val() || "";
            var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']");
            ComponentValue !== "" ? ComponentError.hide() : ComponentError.show()
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // VALIDATE CHECKBOXES
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function ValidateCheckboxes(Component) {
            // because this is structured data we can assume no validation rule other than required is needed
            var ComponentGuid = Component.attr("data-guid");
            var ComponentValue = "";

            $("input[data-guid='" + ComponentGuid + "']:checked").each(function () { ComponentValue += $(this).val() + "|"; });
            ComponentValue.trimEnd("|");

            var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']");
            ComponentValue !== "" ? ComponentError.hide() : ComponentError.show()
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // VALIDATE CHECKBOX
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function ValidateCheckbox(Component) {
            // bool is set is the only kentico validation for this component
            var ComponentCheckbox = Component.parents(".form-group").find(".zag-validation-input-checkbox");
            var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='boolisset']");
            ComponentCheckbox.is(":checked") ? ComponentError.hide() : ComponentError.show()
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // VALIDATE FILE UPLOAD
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function ValidateFile(Component) {
            Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']").each(function () {
                Component.val() !== "" ? $(this).hide() : $(this).show()
            });
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // VALIDATE RECAPTCHA
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function ValidateRecaptcha(Component) {
            var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='recaptcha']");
            var RecaptchaResponse = Component.parent().find(".g-recaptcha-response").val();
            RecaptchaResponse != "" ? ComponentError.hide() : ComponentError.show();
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // COUNT ERRORS
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function CountErrors(Component) {
            // count error messages of individual input and update ui

            Component.parents(".form-group").find(".zag-validation-errors").show();

            var ErrorContainer = Component.parents(".form-group").find(".zag-validation-errors"),
                ErrorContainerId = ErrorContainer.attr("id"),
                ErrorCount = ErrorContainer.children(".zag-validation-error:visible").length,
                AriaDescribedBy = Component.attr("aria-describedby") || "";

            if (ErrorCount > 0) {
                Component.parents(".form-group").addClass("zag-validation-invalid");
                if (AriaDescribedBy != "") { Component.attr("aria-describedby", AriaDescribedBy + " " + ErrorContainerId); }
                else { Component.attr("aria-describedby", ErrorContainerId); }
                ErrorContainer.show();
            }
            else {
                Component.parents(".form-group").removeClass("zag-validation-invalid");
                if (AriaDescribedBy != "") { Component.attr("aria-describedby", AriaDescribedBy); }
                else { Component.removeAttr("aria-describedby"); }
                ErrorContainer.hide();
            }
        }
    }

    return {
        Validation: Validation
    };

})(jQuery);

$(function () {
    App.Forms.Validation();
});